import { RequestBaseFields } from "../types/request.types";

const { fetchUrl, rootPath } = MtsAppVars;

export const mtsUrl = (path: string) => `${fetchUrl}${rootPath}${path}`;

export const requestResourceUrl = (r: RequestBaseFields, resourceType: string) => {
  const reqTypePath = r.request_type.split('_').slice(0, -1).join('_') + 's';
  return mtsUrl(`${reqTypePath}/${r.id}/${resourceType}`);
}
